"use client";

import { useEffect } from "react";
import { Check } from "lucide-react";

interface PasswordStrengthProps {
    password: string;
    onValidityChange?: (isValid: boolean) => void;
}

/** As 5 regras batem 1:1 com o Zod do servidor (registerStoreOwner) — não divergir. */
const requirements = [
    { label: "Pelo menos 8 caracteres", test: (p: string) => p.length >= 8 },
    { label: "Letra maiúscula", test: (p: string) => /[A-Z]/.test(p) },
    { label: "Letra minúscula", test: (p: string) => /[a-z]/.test(p) },
    { label: "Número", test: (p: string) => /[0-9]/.test(p) },
    { label: "Caractere especial (!@#$)", test: (p: string) => /[!@#$%^&*(),.?":{}|<>]/.test(p) },
];

export function PasswordStrength({ password, onValidityChange }: PasswordStrengthProps) {
    const isValid = requirements.every((r) => r.test(password));

    useEffect(() => {
        onValidityChange?.(isValid);
    }, [isValid, onValidityChange]);

    return (
        <div className="mt-1 grid grid-cols-1 gap-x-3.5 gap-y-2 sm:grid-cols-2">
            {requirements.map((req, i) => {
                const met = req.test(password);
                return (
                    <div
                        key={i}
                        className={`flex items-center gap-2 text-[12px] transition-colors ${met ? "text-[var(--mp-pos-text)]" : "text-muted-foreground"}`}
                    >
                        <span
                            className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-[1.5px] transition-all"
                            style={
                                met
                                    ? { backgroundColor: "var(--mp-pos)", borderColor: "var(--mp-pos)" }
                                    : { borderColor: "var(--mp-card-border-strong, #d8d4e6)" }
                            }
                        >
                            <Check className={`h-[9px] w-[9px] text-white transition-opacity ${met ? "opacity-100" : "opacity-0"}`} strokeWidth={3.5} />
                        </span>
                        {req.label}
                    </div>
                );
            })}
        </div>
    );
}
